import { createSelector } from 'reselect'

export const getElement = (state, props) => {
  return state['view-card'].elements.elementsById[props.id]
}

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export default () => createSelector(
  [getElement, getIsCardArchived, getBoardId],
  (element, isCardArchived, boardId) => ({
    isCardArchived,
    boardId,
    content: element.content
  })
)
